import {
  useDeliveryInfo,
  usePickupInfo
} from '~/context/vdp/DeliveryPickupContext';
import { EarliestDate } from '~/contracts/vdp';

export default function useGetEarliestDate(): EarliestDate {
  const delivery = useDeliveryInfo();
  const pickup = usePickupInfo();

  const deliveryIsSooner =
    (delivery?.utcSoonestDateTime || 0) < (pickup?.utcSoonestDateTime || 0);

  return {
    asSoonAsText: deliveryIsSooner
      ? delivery?.asSoonAsText
      : pickup?.asSoonAsText,
    earliestDate: deliveryIsSooner
      ? delivery?.utcSoonestDateTimeIso
      : pickup?.utcSoonestDateTimeIso,
    timeZone: deliveryIsSooner ? delivery?.localTimeZone : pickup?.localTimeZone
  };
}
